/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Comparison
 */
export interface Comparison {
    /**
     * 
     * @type {string}
     * @memberof Comparison
     */
    legacy?: string;
    /**
     * 
     * @type {string}
     * @memberof Comparison
     */
    system?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Comparison
     */
    match?: boolean;
}

/**
 * Check if a given object implements the Comparison interface.
 */
export function instanceOfComparison(value: object): value is Comparison {
    return true;
}

export function ComparisonFromJSON(json: any): Comparison {
    return ComparisonFromJSONTyped(json, false);
}

export function ComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comparison {
    if (json == null) {
        return json;
    }
    return {
        
        'legacy': json['legacy'] == null ? undefined : json['legacy'],
        'system': json['system'] == null ? undefined : json['system'],
        'match': json['match'] == null ? undefined : json['match'],
    };
}

export function ComparisonToJSON(value?: Comparison | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legacy': value['legacy'],
        'system': value['system'],
        'match': value['match'],
    };
}

